import { sanitizeFileName } from '@helpers/sanitizeFileName';
import type { TNameResolver } from '../types/TUploadConfig';

export const defaultNameResolver: TNameResolver = (file, existing) => {
  const base = sanitizeFileName((file && 'name' in file ? file.name : undefined) || 'unnamed');
  const parts = base.split('.');
  const ext = parts.length > 1 ? parts.pop() : undefined;
  const name = (parts.join('.') || 'file').substring(0, 195);
  if (!existing.includes(ext ? `${name}.${ext}` : `${name}`)) {
    return ext ? `${name}.${ext}` : `${name}`;
  }
  let i = 1;
  while (existing.includes(ext ? `${name}-${i}.${ext}` : `${name}-${i}`)) {
    i++;
  }
  return ext ? `${name}-${i}.${ext}` : `${name}-${i}`;
};
